import { Trans, useLingui } from '@lingui/react/macro'
import page404ImageUrl from './assets/404.png'
import page404X2ImageUrl from './assets/404_2x.png'
import { ButtonFilled } from '@vgw/multibrand-fe-button'
import { AppLogo } from '@/features/header/app-logo'
import { Link as MultibrandLink } from '@vgw/multibrand-fe-link'
import { getBrandConfig } from '@/config/config'
import { Link, useNavigate } from '@tanstack/react-router'
import { Layout } from '@/layout/layout'
import { Content } from '@/layout/content'
import { Footer } from '@/features/footer/footer'

export const Page404 = () => {
  const navigate = useNavigate()
  const { name } = getBrandConfig()
  const { t } = useLingui()

  return (
    <Layout>
      <Content>
        <main
          className="flex w-full flex-1 flex-col bg-page-small-background bg-contain bg-top bg-no-repeat 2xl:bg-cover"
          data-testid="page-404"
        >
          <div className="mt-10 flex justify-center">
            <MultibrandLink asChild>
              <Link
                to="/"
                title={t`Go to VGW ${name} Homepage`}
                aria-label={t`Go to VGW ${name} Homepage`}
              >
                <AppLogo className="h-[70px] w-[39px]" />
              </Link>
            </MultibrandLink>
          </div>
          <div className="flex flex-1 flex-col items-center justify-center gap-3 bg-page-gradient p-8 text-center">
            <img
              src={page404ImageUrl}
              width={148}
              height={148}
              alt=""
              srcSet={`${page404ImageUrl} 148w, ${page404X2ImageUrl} 296w`}
            />
            <h1 className="font-display text-2xl font-bold">
              <Trans>Page Not Found</Trans>
            </h1>
            <p className="text-lg font-light">
              <Trans>
                We couldn&apos;t find the page you were looking for.
              </Trans>
            </p>
            <ButtonFilled onClick={() => navigate({ to: '/' })} size="lg">
              <Trans>Go home</Trans>
            </ButtonFilled>
          </div>
        </main>
      </Content>
      <Footer />
    </Layout>
  )
}
